"use strict";

/*global  jQuery*/
//jQuery(function ($) {
$(function () {
  //読み込みが完了
  $(window).on('load',function () { 
    console.log('jQuery Page Loaded.');  
  });
  
  /* iOS動作時の調整処理 */
  $(document).on("touchstart", ".menu-btn", function (event) {
    event.stopPropagation();
  });
  /* ハンバーガーメニューによる開閉処理 */
  $(document).on("click", ".menu-btn.close", function () {
    $(".sp-menu").addClass("open");
    $(".cover").addClass("open");
    $(".cover").removeClass("close");
    $(".sp-menu").removeClass("close");
    $(".menu-btn").addClass("open");
    $(".menu-btn").removeClass("close");
  });
  $(document).on("click", ".menu-btn.open,.cover.open", function () {
    $(".sp-menu").addClass("close");
    $(".sp-menu").removeClass("open");
    $(".cover").removeClass("open");
    $(".cover").addClass("close");
    $(".menu-btn").removeClass("open");
    $(".menu-btn").addClass("close");
  });
  
   //ページトップ戻るボタン 動作
  $(document).on("click", ".btn-child", function () {
    console.log('child-toggle');
    $(this).parent().children('.child-menu').slideToggle();
    $(this).toggleClass('open');
    
  });
  
     //ページトップ戻るボタン 動作
  $(document).on("click", ".btn-search", function () {
    console.log('SEARCH');
    $('.box-search').slideToggle();
  });
  $(document).on("click", ".box-search", function () {
    $('.box-search').slideToggle();
  });
  
  var flg_way = 0;
  
    //ページトップ戻るボタン 表示ギミック
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      $(".btn-pagetop").addClass('visible');
      $(".site-header").addClass('is-scroll');
      if(flg_way == 0) {
        Waypoint.refreshAll(); 
        flg_way =1;
         }
    } else {
      $(".btn-pagetop").removeClass('visible');
      $(".site-header").removeClass('is-scroll');
    }
  });
  
  //ページトップ戻るボタン 動作
  $(document).on("click", ".btn-pagetop", function () {
   console.log('DOM Content Loaded.');
    $('body,html').velocity("scroll", 500);
  });
  
  // スムーズスクロール 
  $(document).on('click', 'a[href*=\\#]:not([href=\\#],.link-movie)', function (event) {
    var href = $(this).attr("href"),
    target = $(href === "#" || href === "" ? 'html' : href);
    target.velocity("scroll", {duration:500, offset:-74});
    return false;
  });
  
  $(document).ready(function(){
    $('.slide-top').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      dots: false,
      centerMode: true,
      autoplay: true,
      autoplaySpeed: 3000,
      pauseOnHover: false,
      speed: 1000,
    });
    
  });

  $('.youtube').colorbox({
      iframe: true,
      maxWidth:"80%",
      maxHeight:"56.24%",
//      maxHeight:"80%",
//      innerWidth: "100%",
//      innerHeight: "56.24%",
     innerWidth:854,
 innerHeight:480,
      scrolling: false
  });
  $('.link-movie').colorbox({
    iframe: false,
    inline: true,
    maxWidth: "60%",
    maxHeight: "80%",
    opacity: 0.7
});
  
    /*
  --------------------------------------
  スクロール処理
  waypoint
  --------------------------------------
  */
  
  // vision 表示
  $(".sec-top").waypoint(function (direction) {
    $(".catch-top.an1").addClass("animated fadeInUp");
    $(".catch-top.an2").addClass("animated fadeInUp");
    $(".lead-top.an3").addClass("animated fadeInUp");
  }, { offset: '50%' });
  
  $(".sec-history").waypoint(function (direction) {
    $(".photo-history").addClass("animated fadeInUp");
    $(".title-history").addClass("animated fadeInUp");
    $(".catch-history").addClass("animated fadeInUp");
    $(".text-history").addClass("animated fadeInUp");
    $(".btn-history").addClass("animated fadeInUp");
  }, { offset: '50%' });

  $(".sec-topics").waypoint(function (direction) {
    $(".catch-topics").addClass("animated fadeInUp");
    $(".btn-topics").addClass("animated fadeInUp");
  }, { offset: '50%' });
  
  $(".sec-movie").waypoint(function (direction) {
    $(".photo-movie").addClass("animated fadeInUp");
    $(".info-movie").addClass("animated fadeInUp");
    $(".title-movie").addClass("animated fadeInUp");
    $(".catch-movie").addClass("animated fadeInUp");
    $(".text-movie").addClass("animated fadeInUp");
    $(".btn-movie").addClass("animated fadeInUp");
  }, { offset: '50%' });
  
  $(".sec-message").waypoint(function (direction) {
    $(".photo-message").addClass("animated fadeInUp");
    $(".title-message").addClass("animated fadeInUp");
    $(".catch-message").addClass("animated fadeInUp");
    $(".text-message").addClass("animated fadeInUp");
    $(".btn-message").addClass("animated fadeInUp");
  }, { offset: '50%' });
  
  
    // vision 表示
  $(".row-timeline").waypoint(function (direction) {
    var activePoint = $(this.element);
    
    activePoint.addClass("animated fadeInUp");
//    $(this).addClass("animated fadeInUp");
//    $(".catch-top.an2").addClass("animated fadeInUp");
//    $(".lead-top.an3").addClass("animated fadeInUp");
  }, { offset: '80%' });
  //  }, { offset: '50%' });
  
  $(".title-timeline").waypoint(function (direction) {
    var activePoint = $(this.element);
    activePoint.addClass("animated fadeInUp");
  }, { offset: '80%' });
  
});

//touchstartに対応してたらtouchstart、してなければclick
const myTap = window.ontouchstart===null?"touchstart":"click";

// DOM読み込み完了
document.addEventListener('DOMContentLoaded', function(e) {
//  console.log('DOM Content Loaded.');
}, false);

// 完全に読み込み完了
window.addEventListener('load', function() {
//  console.log('Page Loaded.');
});
